import { Display } from '@/components/Display/Display';
import { errMap, errMsgMap } from '@/utils/Page/constant';
import Error from '@/components/Web/Error';
import agentErrImg from '@/assets/images/mobile/agent_error.webp';
import noAuthImg from '@/assets/images/res/no-auth.webp';
import emptyImg from '@/assets/images/res/empty.webp';
import { Button } from 'antd';
import chatStore from '@/store/grtAi/chat';

const AgentError = (props) => {
    let { code } = props.err;
    let img = {
        [errMap.errlink]: emptyImg,
        [errMap.businessOff]: emptyImg,
        [errMap.noOper]: noAuthImg
    };
    const handleOutLogin = async () => {
        let res = await chatStore.handleOutLogin(false);
        if (res) {
            let origin = window.location.origin;
            window.location.replace(`${origin}/login?redirect=${(window.location.href)}`);
        }
    };
    return (
        <>
            <Display show={code !== errMap.noOper}>
                <Error text={errMsgMap[code]} img={img[code] || emptyImg}></Error>
            </Display>
            <Display show={code === errMap.noOper}>
                <Error
                    text={errMsgMap[code]}
                    img={img[code] || emptyImg}
                    action={
                        <Button onClick={handleOutLogin} style={{ marginTop: 24 }} type="primary">
                            退出登录
                        </Button>
                    }
                ></Error>
            </Display>
        </>
    );
};

export default AgentError;
